<template>
  <div class="index">

    <div class="index-logo">
      <img src="../../assets/img/logom.png">
    </div>

    <div class="index-swiper">
      <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in swipers" :key="item">
              <img :src="item" class="swiper-img">
            </div>
        </div>
      </div>
    </div>

    <div class="index2">
      <img src="/static/m/idea.png">
    </div>

    <div class="index2">
      <img src="../../assets/img/12.png">
    </div>

    <div class="index2">
      <img src="/static/m/flow.png">
    </div>

    <div>
      <div class="company">
        <div class="company-left">
          <div class="company-left-zh">公司动态</div>
          <div class="company-left-en">COMPANY NEWS</div>
          <div class="company-left-content">{{news.content}}</div>
          <div class="company-left-more"><img src="/static/m/more.png"></div>
        </div>
        <div class="company-rigth">
          <img src="/static/m/company.png">
        </div>
        <div style="clear:both;"></div>
      </div>
    </div>

    <div class="index2">
      <img src="../../assets/img/13.png">
    </div>

    <div class="index5">
      <img src="../../assets/img/14.png">
    </div>

    <div class="footer">
      <p>
        <a target="_blank" href="https://beian.miit.gov.cn/">闽ICP备2021010769号</a>
        <br/>
        Copyright © 2021 - 2021 WJY. All Rights Reserved. 
        <br/>
        厦门万聚源信息科技有限公司 版权所有</p>
    </div>
  </div>
</template>

<script>
import '@/assets/swiper/swiper-bundle.min.js'
export default {
  name: 'Mindex',
  data () {
    return {
      swipers: [
        require('../../../static/m/5.png'),
        require('../../../static/m/banner.png'),
      ],
      news: {},
    }
  },
  mounted(){
     var mySwiper = new Swiper ('.swiper-container', {
      loop: true,
      autoplay: {
        delay: 2000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
      },
    })
  },
  created () {
    this.getNews()
  },
  methods: {
    getNews () {
      this.$axios.get('//api.kankan.run/wjynew/getShow').then(res => {
        if (res.data.code == 200) {
          this.news = res.data.data
        }
      })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../assets/swiper/swiper-bundle.min.css';
.swiper-img{
  width: 100%;
  overflow: hidden;
}
.index-swiper{
  /* position: absolute;
  top: 0;
  left: 0;
  right: 0; */
  overflow: hidden;
  /* z-index: 0; */
}
.swiper-container{
  width: 100%;
  overflow: hidden;
  --swiper-theme-color: #ffffff;
  --swiper-pagination-color: #ffffff;/* 两种都可以 */
}
.footer{
  color: #929797;
  text-align: center;
  font-size: 12px;
}
.footer a{
  cursor: pointer;
  color: #929797;
  text-decoration: none;
}
.index2>img{
  width: 100%;
}
.index5>img{
  width: 70%;
  margin: 15%;
}
.index-logo{
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 10;
}
.index-logo>img{
  width: 40%;
}
.company{
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.company-left{
  width: 50%;
  float: left;
}
.company-left-zh{
  margin-left: 1rem;
}
.company-left-en{
  margin-left: 1rem;
  color: #999999;
  font-size: 0.8rem;
}
.company-left-content{
  margin: 1rem;
  color: #999999;
  font-size: 0.6rem;
}
.company-left-more{
  margin-left: 1rem;
}
.company-left-more>img{
  width: 40%;
}
.company-rigth{
  width: 50%;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/m/Index.vue